module.exports = __webpack_public_path__ + "img/EricGorlee_140x140_rund.8d0579f7.jpg";